import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createCasinoGameStart, getAllCasinoProvidersStart, getSuperAdminGameSubCategoryStart, updateCasinoGameStart } from '../../../../store/redux-slices/superAdminCasinoManagement'

const useCreateCasinoGame = () => {
  const dispatch = useDispatch()
  const { casinoProvidersData, loading,gameSubCategory } = useSelector(
    (state) => state.superAdminCasino
  )

  useEffect(() => {
    dispatch(getAllCasinoProvidersStart({ limit: '', pageNo: '' }))
  }, [])

  const updateCasinoGame = ({
    data,
    casinoProviderId,
    limit,
    pageNo
  }) => dispatch(
    updateCasinoGameStart({
      data,
      casinoProviderId,
      limit,
      pageNo
    })
  )

  const createCasinoGame = ({
    data,
    casinoProviderId,
    limit,
    pageNo
  }) =>
    dispatch(
      createCasinoGameStart({
        data,
        casinoProviderId,
        limit,
        pageNo
      })
    )

  return {
    casinoProvidersData, loading, updateCasinoGame, createCasinoGame
  }
}

export default useCreateCasinoGame
